import styled, { css, keyframes } from 'styled-components'

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`

const shimmerEffect = css`
  background: linear-gradient(90deg, #f0f0f0 25%, #f7f7f7 37%, #f0f0f0 63%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.4s ease infinite;
`

export const SkeletonCard = styled.div<{ $height: number }>`
  margin-bottom: 16px;
  overflow: hidden;

  .image-skeleton {
    width: 100%;
    height: ${(props) => props.$height}px;
    border-radius: 16px;
    ${shimmerEffect}
  }

  .title-skeleton {
    height: 14px;
    width: 80%;
    margin: 10px 0;
    border-radius: 4px;
    ${shimmerEffect}
  }

  .date-skeleton {
    height: 12px;
    width: 40%;
    border-radius: 4px;
    ${shimmerEffect}
  }
`

export const Wrapper = styled.div`
  background: var(--Bg_, #f2f0ef);
  min-height: 100vh;
  width: 100%;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  position: relative;
`

export const Header = styled.header`
  display: flex;
  height: 52px;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  width: 100%;
`

export const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 24px;
  font-weight: bold;
`

export const MainContent = styled.main`
  overflow-y: scroll;
  scroll-behavior: smooth;
  padding: 20px 80px;
  height: calc(100vh - 52px);
  text-align: center;
  .masonry-grid {
    display: flex;
    width: 100%;
    margin-left: -20px; /* 调整间距 */
  }

  .masonry-grid_column {
    padding-left: 20px; /* 调整间距 */
    background-clip: padding-box;
  }
`

export const CardList = styled.div`
  display: grid;
  grid-gap: 20px;
  position: relative;
  margin: 0 auto;
  width: 100%;

  @media (min-width: 1000px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 1400px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (min-width: 1800px) {
    grid-template-columns: repeat(5, 1fr);
  }
`

export const Card = styled.div<{ $height: number }>`
  margin-bottom: 16px;
  overflow: hidden;
  cursor: pointer;
  border-radius: 16px;
  padding-right: 16px;

  img {
    width: 100%;
    // aspect-ratio: 3 / 4;
    // height: ${(props) => props.$height}px;
    transition: box-shadow 0.3s ease;
    border-radius: 16px;
    object-fit: cover;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    &:hover {
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    }
  }

  a {
    padding: 10px;
    margin: 0;
    font-size: 12px;
    color: #424242;
  }
  span {
    display: block;
    font-size: 12px;
    color: #333;
    text-align: center;
  }
`

export const UserPanel = styled.div`
  position: absolute;
  left: 0;
  transform: translateX(-50%);
  bottom: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 12px;
  border-radius: 8px;
  width: 32px;
`

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }

  span {
    display: block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #667699;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    text-align: center;
  }
`

export const LogoutButton = styled.div`
  border: none;
  cursor: pointer;
`

export const ContentTitle = styled.h1`
  color: var(--Grays-Black, #07091e);
  font-family: Rubik;
  font-size: 34px;
  font-style: normal;
  font-weight: 600;
  line-height: 34px; /* 100% */
  text-indent: 87px;
`

// ... 其他样式保持不变

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  text-align: center;
  color: #666;
  min-height: 300px;

  .icon {
    font-size: 48px;
    margin-bottom: 16px;
    color: #999;
  }

  .title {
    color: var(--Grays-Gray-2, #424242);
    text-align: center;
    font-family: Rubik;
    font-size: 34px;
    font-style: normal;
    font-weight: 500;
    line-height: 34px; /* 100% */
    margin-bottom: 24px;
  }

  .subtitle {
    color: var(--Grays-Gray-3, #777e90);
    text-align: center;
    font-family: Rubik;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
  }
`
